import { DialogRef, DialogService } from "@progress/kendo-angular-dialog";
import { ContragentsService } from "../../../../categories/contragents/contragents.service";
import { ContragentWithContactDto } from "../../../../shared/models/contragent/contragent-with-contact-dto";
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { KeyValueObject } from "../../../../shared/models/core/KeyValueObject";
import { Subscription } from "rxjs";
import { Contragent } from "../../../../shared/models/contragent/Contragent";
import { CreateContragentComponent } from "../../../../shared/components/contragents/create-contragent/create-contragent.component";
import { CustomerObjectsService } from "../../../../categories/customer-objects/customer-objects.service";
import { CustomerObjectWithContactsDto } from "../../../../shared/models/customerObject/customer-object-with-contacts.dto";
import { AutoCompleteComponent } from "@progress/kendo-angular-dropdowns";
import { MaskedTextBoxComponent } from "@progress/kendo-angular-inputs";
import { ClientSelectionService as ContragentSelectionService } from "../contagent-selection-service";
import { DropdownListCountryPhoneMasksComponent } from "../../../../shared/components/dropdownlist-country-phone-masks/dropdownlist-country-phone-masks.component";
import { AddressClarificationComponent } from "../../../../shared/components/adresses/address-clarification/address-clarification.component";
import { UsersService } from "../../../../admin/users/users.service";

@Component({
	selector: 'new-request-client-info',
	templateUrl: './new-request-client-info.component.html',
	styleUrls: ['./new-request-client-info.component.scss']
})
export class NewRequestClientInfoComponent implements OnInit {

	@ViewChild('clientAutocomplete') clientAutocomplete: AutoCompleteComponent
	@ViewChild('phoneMaskedboxAutocomplete') phoneMaskedboxAutocomplete: AutoCompleteComponent;
	@ViewChild('countryPhoneMasksComponent') countryPhoneMasksComponent: DropdownListCountryPhoneMasksComponent;

	@Input() selectedContragent: ContragentWithContactDto;
	@Input() showHeaderIcon: boolean = true;
	@Input() isReadonly: boolean = false;
	@Input() selectedServiceCenterId: number = null;

	/** Данные для формы «Новый клиент» при переходе из лида без ContragentId. */
	@Input() leadNewClientPrefill: Partial<ContragentWithContactDto> = null;

	/** Ид лида из контекста создания заявки (?leadId=). */
	@Input() sourceLeadId: number = null;

	@Output() saveContragent: EventEmitter<ContragentWithContactDto> = new EventEmitter<ContragentWithContactDto>();
	@Output() saveCustomerObject: EventEmitter<number> = new EventEmitter<number>();

	cellPhoneMask: string = "+7 (000) 000-00-00";
	public rules: { [key: string]: RegExp } = {
		'0': /\d/
	};

	contragentSearchPauseTime = 500;
	contragentsSearchDelay: NodeJS.Timer;
	contragentsSearchSubsription: Subscription;
	searching: boolean = false;

	searchedPhone: string;
	defaultContragent: KeyValueObject = new KeyValueObject(null, 'Не выбрано');
	contragents: KeyValueObject[] = [];
	selectedContragentId: number;
	selectedContragentName: string;

	contragentSelectionSubscription: any;
	defaultUserServiceCenterId: number = null;

	constructor(
		public contragentsService: ContragentsService,
		public dialogService: DialogService,
		public customerObjectsService: CustomerObjectsService,
		public contragentSelectionService: ContragentSelectionService,
		private usersService: UsersService
	) { }

	ngOnInit(): void {
		this.usersService.getLookupUserServiceCenters().subscribe(serviceCenters => {
			const defaultSc = (serviceCenters || []).find(x => x.isDefault)
				|| (serviceCenters || [])[0];
			this.defaultUserServiceCenterId = defaultSc ? defaultSc.id : null;
		});

		this.contragentSelectionSubscription = this.contragentSelectionService.contragentForced$.subscribe(
			(contragentName) => {
				this.contragentsSearchSubsription = this.contragentsService.searchByName(contragentName, false)
					.subscribe((response) => {
						this.contragents = response.data;
						this.clientChange(this.contragents[0].name);
					});
			}
		);

		if (this.selectedContragent != null) {
			this.selectedContragentId = this.selectedContragent.id;
			this.setSelectedContragentName(this.selectedContragent);
			this.searchedPhone = this.selectedContragent.contactPhone;
		}
	}

	ngOnDestroy() {
		if (this.contragentSelectionSubscription) {
			this.contragentSelectionSubscription.unsubscribe();
		}
	}

	clientChange(value: string): void {
		let contragent = this.contragents.find(x => x.name == value);
		this.selectedContragentId = contragent != null ? contragent.id : null;

		if (this.selectedContragentId == null || this.selectedContragentId == 0) {
			this.selectedContragent = null;
			this.saveContragent.emit(this.selectedContragent);
		}
		else {
			this.contragentsService.getContragentWithContact(this.selectedContragentId).subscribe(resp => {
				this.setSelectedContragentName(resp);
				this.selectedContragent = resp;
				this.searchedPhone = resp.contactPhone;
				this.refreshMask();
				this.saveContragent.emit(this.selectedContragent);
			});
		}
	}

	clientPhoneFilterChange(value: string) {
		this.clientFilterChange(value, true);
	}

	clientFilterChange(value: string, searchOnlyByPhone: boolean = false): void {
		if (!value || value.trim() == '' || value.trim().length < 3) {
			this.contragents = this.selectedContragent != null
				? this.contragents.filter(x => x.id == this.selectedContragentId)
				: [];
		}
		else {
			this.searchContragents(value, searchOnlyByPhone);
		}
	}

	searchContragents(value: string, searchOnlyByPhone: boolean = false) {
		if (this.contragentsSearchDelay) {
			clearTimeout(this.contragentsSearchDelay);
		}

		this.contragentsSearchDelay = setTimeout(() => {
			if (this.contragentsSearchSubsription) {
				this.contragentsSearchSubsription.unsubscribe();
			}

			this.searching = true;
			this.contragentsSearchSubsription = this.contragentsService.searchByName(value, searchOnlyByPhone)
				.subscribe((response) => {
					this.searching = false;
					this.contragents = response.data;
				});
		}, this.contragentSearchPauseTime);
	}

	showAddressClarification(contragent: ContragentWithContactDto, parentDialog: DialogRef) {
		const dialogRef = this.dialogService.open({
			content: AddressClarificationComponent,
			width: '80%',
			height: '820px',
			minWidth: '800px'
		});
		const addressClarification = <AddressClarificationComponent>dialogRef.content.instance;

		addressClarification.height = 460;
		addressClarification.address = contragent.address;
		addressClarification.onCancelEvent.subscribe(() => {
			
			dialogRef.close();
		});
		addressClarification.onContinueEvent.subscribe(yandexModel => {

			let mainCustomerObject = {
				contragentId: contragent.id,
				address: contragent.address,
				addressDescription: contragent.addressDescription,
				name: 'Основной',
				yandexModel: yandexModel,
				serviceCenterId: this.resolveServiceCenterIdForNewObject()
			} as CustomerObjectWithContactsDto;

			this.customerObjectsService.createCustomerObjectWithContacts(mainCustomerObject).subscribe((resp) => {
				if (resp.isSuccessful) {
					this.saveCustomerObject.emit(resp.data.id);
					parentDialog.close();
					dialogRef.close();
				}
			});
		});
	}


	applyContragentFromExternal(contragent: ContragentWithContactDto): void {
		this.saveSelectedContragent(contragent);
	}

	openCreateContragentDialog() {
		const dialogRef = this.dialogService.open({ content: CreateContragentComponent, width: '60%', height: '640px' });
		const createContragentForm = <CreateContragentComponent>dialogRef.content.instance;

		let isEditing = this.selectedContragent != null
		createContragentForm.isEditing = isEditing;
		createContragentForm.contragentEntity = this.selectedContragent;
		createContragentForm.defaultContactPhone = this.searchedPhone;
		createContragentForm.initialNewContragentPrefill = !isEditing ? this.leadNewClientPrefill : null;
		createContragentForm.sourceLeadId = !isEditing ? this.sourceLeadId : null;
		createContragentForm.onCancelEvent.subscribe(() => dialogRef.close());
		createContragentForm.onContinueEvent.subscribe((contragent: ContragentWithContactDto) => {
			if (isEditing) {
				this.saveSelectedContragent(contragent);
				dialogRef.close();
			}
			else {
				let mainCustomerObject = {
					contragentId: contragent.id,
					address: contragent.address,
					addressDescription: contragent.addressDescription,
					name: 'Основной',
					yandexModel: contragent.yandexModel,
					serviceCenterId: this.resolveServiceCenterIdForNewObject()
				} as CustomerObjectWithContactsDto;

				this.customerObjectsService.createCustomerObjectWithContacts(mainCustomerObject).subscribe((customerObjectIdResp) => {
					this.saveSelectedContragent(contragent);
					if (customerObjectIdResp.isSuccessful) {
						if (customerObjectIdResp.data.addressOk) {
							this.saveCustomerObject.emit(customerObjectIdResp.data.id);
							dialogRef.close();
						} else {
							this.showAddressClarification(contragent, dialogRef);
						}
					}
				});
			}
		});
	}

	saveSelectedContragent(contragent: ContragentWithContactDto) {
		this.selectedContragent = contragent;
		this.saveContragent.emit(this.selectedContragent);
		this.selectedContragentId = contragent.id;
		this.searchedPhone = contragent.contactPhone;
		this.refreshMask();

		const contragentNameData = [contragent.contactFullName, contragent.contactPhone, contragent.name, contragent.inn];
		const contragentDisplayName = contragentNameData.filter(s => s !== null && s.trim() != '').join(', ');
		this.setSelectedContragentName(contragent);
		this.contragents = [new KeyValueObject(contragent.id, contragentDisplayName)];

		this.clientFilterChange(null);
	}

	setSelectedContragentName(contragent: ContragentWithContactDto) {
		if (contragent.isIndividual) {
			this.selectedContragentName = contragent.contactFullName
				? contragent.contactFullName
				: contragent.contactPhone;
		}
		else {
			let innText = contragent.inn
				? `(ИНН ${contragent.inn})`
				: '';

			this.selectedContragentName = contragent.name
				? `${contragent.name} ${innText}`
				: innText;
		}
	}

	changeSearchedPhone() {
		let value = this.searchedPhone.replace(/\D/g, '')
		this.phoneMaskedboxAutocomplete.value = value;
		this.phoneMaskedboxAutocomplete.filterChange.next(value);
		this.phoneMaskedboxAutocomplete.togglePopup(true);
	}

	setMask(mask: string) {
		this.cellPhoneMask = mask;
		this.searchedPhone = '';
	}

	refreshMask() {
		this.cellPhoneMask = this.countryPhoneMasksComponent.getAndSetPhoneMask(this.searchedPhone);
	}

	blurPhoneMaskedBox() {
		this.phoneMaskedboxAutocomplete.togglePopup(false);

		if (this.selectedContragent != null) {
			this.searchedPhone = this.selectedContragent.contactPhone;
			this.refreshMask();
		}
	}

	private resolveServiceCenterIdForNewObject(): number {
		if (this.selectedServiceCenterId != null && this.selectedServiceCenterId > 0) {
			return this.selectedServiceCenterId;
		}

		return this.defaultUserServiceCenterId;
	}
}
